import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-config",
	templateUrl: "./manage-config.component.html",
	styleUrls: ["./manage-config.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ActionButtonComponent, FormsModule]
})
export class ManageConfigComponent implements OnInit {
	api = inject(ApiService);

	public treenodes: OrganizationWithConfigs[];
	public selectedItem: AssetConfigWithAssets;
	public selectedVersion: string;
	public oldConfig: string;
	public newConfig: string;

	ngOnInit() {
		this.UpdateTree();
	}

	public async UpdateTree() {
		const [orgs, configs, assets] = await Promise.all([
			await this.api.GetOrganizations(),
			await this.api.GetAllConfigs(),
			await this.api.GetAllAssets(),
		]);
		for (const org of orgs as OrganizationWithConfigs[]) {
			const orgconfigs = configs.filter(item => item.organization_id === org.organization_id) as AssetConfigWithAssets[];
			for (const config of orgconfigs) {
				config.assets = assets.filter(item => item.asset_type_id === config.asset_type_id);
			}
			org.configs = orgconfigs;
		}
		this.treenodes = orgs;
	}

	public async ClickExpander($event: any) {
		$event.target.parentElement.classList.toggle("expanded");
	}

	public async ClickOrg($event: any) {
		$event.target.parentElement.classList.add("expanded");
	}

	public async ClickConfig($event: any, config: APIResults.AssetConfig) {
		this.selectedItem = config;
		this.oldConfig = await this.api.GetConfigContent(this.selectedItem.asset_type_id);
		this.selectedVersion = this.FindVersion(this.oldConfig);
	}

	public DuplicateConfig() {
		this.newConfig = this.oldConfig;
	}

	public async DeleteConfig() {
		await this.api.DeleteConfig(this.selectedItem.asset_type_id);
		await this.UpdateTree();
		this.selectedItem = undefined;
	}

	async UpdateConfig() {
		await this.api.UpdateConfig(this.selectedItem.asset_type_id, this.newConfig);
		this.oldConfig = await this.api.GetConfigContent(this.selectedItem.asset_type_id);
	}

	private FindVersion(config: string): string {
		const versionMatch = config.match(/<asmtype.*?version\s*=\s*"(.*?)"/);
		return versionMatch ? versionMatch[1] : "Unknown";
	}
}

interface OrganizationWithConfigs extends APIResults.Organization {
	configs?: AssetConfigWithAssets[];
}

interface AssetConfigWithAssets extends APIResults.AssetConfig {
	assets?: APIResults.Asset[];
}